import { useContext, useMemo } from 'react'
import moment from 'moment'
import { GlobalContext } from '../../../App'

// Shared "who can do what in Make Ready" rules. The sidebar reads teams from
// user.employee.teams; a few older Make Ready pages read user.teams - accept
// both so the module can't drift depending on which shape it is handed.
const getTeams = (user) => user?.employee?.teams || user?.teams || []

export const isSiteAdmin = (user) => !!user?.security?.isSiteAdmin

const LOAD_LIST_EDITOR_TEAMS = ['Governance', 'Manager', 'Supervisor']
const MAKE_READY_MANAGER_TEAMS = [
  'Fleet',
  'Make Ready',
  'Governance',
  'Manager',
  'Supervisor',
]

// Create / edit / delete load lists and see the Load Lists tab.
export const canEditLoadLists = (user) =>
  isSiteAdmin(user) ||
  LOAD_LIST_EDITOR_TEAMS.some((team) => getTeams(user).includes(team))

// Assign or change the load list on a vehicle/asset.
export const canManageMakeReady = (user) =>
  isSiteAdmin(user) ||
  MAKE_READY_MANAGER_TEAMS.some((team) => getTeams(user).includes(team))

// Mirrors SubscriptionGate's access test (tier or active initial trial) so
// inline Make Ready blocks outside the gated routes hide on lower tiers.
export const useMakeReadyTierAllowed = (requiredTier = 2) => {
  const { tenantInfo } = useContext(GlobalContext)
  return useMemo(() => {
    if (!tenantInfo) return false
    const inTrial =
      tenantInfo?.inInitialTrialPeriod &&
      tenantInfo?.trialEnd &&
      moment(tenantInfo.trialEnd).isAfter(moment())
    const sufficientTier =
      Number(tenantInfo?.subscriptionTier ?? 0) >= Number(requiredTier)
    return !!(inTrial || sufficientTier)
  }, [tenantInfo, requiredTier])
}
